import { toCtaData } from "@/contents/converters/atoms"
import BlokWrapper from "@/contents/integrations/BlokWrapper"
import { SanityDecoration } from "@/contents/molecules/SanityDecoration"
import SanityStackedImages from "@/contents/molecules/SanityStackedImages"
import { ImageText2 } from "@/contents/sanityTypes"
import SanityRichTextField from "@/integrations/sanity/components/SanityRichTextField"
import TextImageBlock from "@/ui/organisms/TextImageBlock"

export interface SanityImageText2Props {
  content: ImageText2
}

const SanityImageText2 = ({ content }: SanityImageText2Props) => {
  return (
    <BlokWrapper contents={content} menuColor="text" className="xl:pb-[60px]">
      <TextImageBlock
        image={
          content.stackedImages ? (
            <SanityStackedImages
              content={content.stackedImages}
              alignment={content.direction === "reverse" ? "left" : "right"}
              className="xl:pb-[50%]"
            />
          ) : undefined
        }
        title={<SanityRichTextField value={content.title} />}
        bodyTitle={<SanityRichTextField value={content.bodyTitle} />}
        text={<SanityRichTextField value={content.body} multiline />}
        cta={toCtaData(content.cta)}
        decoration={
          content.decoration?.image?.asset ? (
            <SanityDecoration
              asset={content.decoration.image.asset}
              position={content.decoration.position ?? {}}
              size={content.decoration.size ?? {}}
              absolute
            />
          ) : undefined
        }
        orientation={content.direction}
      />
    </BlokWrapper>
  )
}

export default SanityImageText2
